import {useQuery} from 'react-query';
import {getFarmSaleTypes} from 'services/farm/advertisement/add/saleTypes';
const useGetSaleType = (cultivationGuid: string) => {
  const {data, isLoading} = useQuery(
    ['farm-sales-type', cultivationGuid],
    getFarmSaleTypes,
  );
  return {farmTypeSales: data, isLoading};
};

export default useGetSaleType;
